var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c("div", { staticClass: "field" }, [
      _c("div", { staticClass: "label text-caption text-uppercase" }, [
        _vm._v(_vm._s(_vm.labelPrefix) + " Vat id"),
      ]),
      _c("span", [_vm._v(_vm._s(_vm.details.vatId))]),
    ]),
    _vm.details.certificateId
      ? _c(
          "div",
          { staticClass: "field" },
          [
            _c("div", { staticClass: "label text-caption text-uppercase" }, [
              _vm._v(_vm._s(_vm.labelPrefix) + " Id Proof"),
            ]),
            _c("VatCertificate", {
              attrs: { "certificate-id": _vm.details.certificateId },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm.additionalNote
      ? _c(
          "p",
          {
            staticClass: "text-caption mt-2",
            class: `${_vm.additionalNote.color}`,
          },
          [
            _c("span", { staticClass: "font-weight-bold mr-2" }, [
              _vm._v("Note:"),
            ]),
            _c("span", [_vm._v(_vm._s(_vm.additionalNote.text))]),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }